import { Signup } from '../signup';

// Run this function after page loaded
document.addEventListener("DOMContentLoaded", async function() {
    const signup = new Signup();

	//Get the signup form elements
	const nameInput = document.getElementById("signups-name-input") as HTMLInputElement;

	if(!nameInput) {
		throw new Error("Signups name input element with id='signups-name-input' not found");
	}

	const emailInput = document.getElementById("signups-email-input") as HTMLInputElement;

	if(!emailInput) {
		throw new Error("Signups email input element with id='signups-email-input' not found");
	}

	const subscribeButton = document.getElementById("signups-submit-btn") as HTMLButtonElement;

	if(!subscribeButton) {
		throw new Error("Signups subscribe button element with id='signups-submit-btn' not found");
	}

	const subscribeErrorMessage = document.getElementById("signups-subscribe-error-message") as HTMLDivElement;

	if(!subscribeErrorMessage) {
		throw new Error("Signups subscribe error message element with id='signups-subscribe-error-message' not found");
	}


    signup.setupSignup(nameInput, emailInput, subscribeButton, subscribeErrorMessage);
});